module.exports = __webpack_public_path__ + "media/gallery-birthday.baa4680f.webm";